export default function IconStar(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.00208 0.75C8.657 0.75 8.30442 0.9375 8.15438 1.32L6.35397 5.7225L1.59787 6.0675C0.78018 6.1275 0.450104 7.1475 1.08025 7.68L4.71859 10.7475L3.57833 15.36C3.42829 15.9825 3.9159 16.5 4.47103 16.5C4.62857 16.5 4.79361 16.455 4.95114 16.3575L9.00208 13.8525L13.053 16.3575C13.2106 16.455 13.3756 16.5 13.5331 16.5C14.0883 16.5 14.5759 15.9825 14.4258 15.36L13.2856 10.7475L16.9239 7.68C17.5541 7.1475 17.2165 6.1275 16.3988 6.0675L11.6502 5.7225L9.84978 1.32C9.69974 0.9375 9.34716 0.75 9.00208 0.75Z"
        fill="currentColor"
      />
    </svg>
  );
}
